<div class="not-authorized">
  <mat-icon>{{ icon }}</mat-icon>
  <h2>{{ titleKey | t }}</h2>
  <p>{{ messageKey | t }}</p>
  <div class="actions">
    @if (showSignIn) {
      <button mat-flat-button color="primary" type="button" (click)="signIn()">
        {{ 'header.signIn' | t }}
      </button>
      @if (canGoToTree) {
        <a mat-button [routerLink]="['/tree', treeUrl]">{{ 'common.backToTree' | t }}</a>
      }
    } @else if (canGoToTree) {
      <a mat-flat-button color="primary" [routerLink]="['/tree', treeUrl]">{{ 'common.backToTree' | t }}</a>
    }
    <a mat-button [routerLink]="['/']">{{ 'common.homePage' | t }}</a>
  </div>
</div>
